module.exports = __webpack_public_path__ + "static/media/8OLA24.c18ce1eb.jpg";